/**
 * versionreducer.js
 * Created by calhosh on 9/22/2020.
 */
import initialState from './initialstate';
import * as types from "../actions/actiontypes";

export default function VersionUpgradeStateReducer(
	state = initialState.appVersion,
	action
) {
	switch (action.type) {
		case types.VERSION_UPDATE:
			return {
				upgrade: action.upgrade,
				version: action.version
			};
		default:
			return state;
	}
}
